import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Chip, CircularProgress, Grid, Paper, Button,  TextField , Modal, Skeleton, Typography , IconButton, InputAdornment} from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import MyTable from '../../components/Schedule/MyTable';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setMyBalance, setMyShifts } from '../../store/myShiftsReducer'
import MyTeamHeader from '../../components/MyTeam/MyTeamHeader';
import { toast } from 'react-toastify';
import SearchIcon from "@mui/icons-material/Search";
import AuthContext from '../../context/AuthContext';

export default function MyTeamNew() {
  const dispatch = useDispatch()
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
	const [rows2 , setRows2] = useState([])
  const [date, setDate] = useState([])
  const [openCollapse, setOpenCollapse] = useState(false)
  const MyShifts = useSelector((state) => state.myShiftsReducer.Data)
  const { pagesName } = useContext(AuthContext);
	const [searchText, setSearchText] = useState('');
	const [values , setValues] = useState(0);
	const [shiftsData , setShiftsData] = useState([]);
	const { user } = useContext(AuthContext);

  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
    ? pagesName.GROUP_HEADER_TEXT
    : "Group";

  const printRef = useRef();
  const handlePrint = useReactToPrint({
	contentRef: printRef,
  });


	const shiftTypes = () =>{
		ApiService.get('/shiftTypes').then(({ data }) => {
			setShiftsData(data?.data || [])
		}).catch(() => {
			console.error("Error")
		})
	}

	useEffect(()=>{
		shiftTypes()
	} , [])


	const loadData = (dateInput = '') => {
    setLoading(true)
    ApiService.get('/myTeam')
		.then(({ data }) => {

			// if(
			// 	data?.has_schedule_data == true ? 
			// 	setRows(data?.schedule_stations?.flatMap(station => station.employees) || []):
			// 		data?.has_volunteer_data == true ?
			// 		setRows(data?.volunteer_stations) :
			// 			setRows(data?.alternate_schedule)
			// )

			const scheduleEmployees = data?.schedule_stations?.flatMap(
        station => station.employees || []
      ) || [];

      const volunteerEmployees = data?.volunteer_stations?.flatMap(
        station => station.employees || []
      ) || [];

      const alternateEmployees = data?.alternate_schedule?.map(item => ({
        ...item.Emp,
        Shifts: item.Shifts,
        Overtime: item.Overtime,
        Overrides: item.Overrides,
      })) || [];

			const detailEmployees = data?.detail_shifts?.map(item => ({
        ...item,
      })) || [];

      const combinedRows1 = [
        ...scheduleEmployees,
        ...volunteerEmployees,
        ...alternateEmployees,
				...detailEmployees,
      ].map((row, index) => ({
        ...row,
        id: index + 1, 
      }));

			const combinedRows2 = [
        ...scheduleEmployees,
        ...volunteerEmployees,
        ...alternateEmployees,
				...detailEmployees,
      ].map((row, index) => ({
        ...row,
        id: index + 1, 
				heightOfRow: 'myTeamTableHeight'
      }));

      setRows(combinedRows1);
			setRows2(combinedRows2)

      setDate(data.date)
      setLoading(false)
    }).catch(() => {
      toast.error("Error")
      setLoading(false)
    })
    ApiService.get('/myShifts', {}, 'myShifts').then(({ data }) => {
      dispatch(setMyShifts(data.MySchedule));
      if (data.MyBalance) {
        dispatch(setMyBalance(Object.values(data.MyBalance)));
      }
      setLoading(false)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
    })
  }

  useEffect(() => {
    loadData()
  }, [])

	const getDisplayName = (row) => {
		const emp = row.employee;
		const fullName = row.fullName || (emp ? emp.fullName : '');
		const rank = row.EA_Rank || (emp ? emp.EA_Rank : '');

		const shifts = row.overtimeShifts || [];
		const shiftsNew = row?.Overtime;


		if(row?.overtimeShifts?.length === 0 || row.Overtime?.length == 0){
			return `${rank ? rank + ' ' : ''}${fullName}`;
		}

		else{
			return (
				<div style={{ display:'flex', alignItems:'center' , gap: 2 }}>
					{fullName ?
						<p style={{marginTop:'0px' , marginBottom:'0px' , marginRight:'6px' , width:'130px' }}>{rank ? rank + ' ' : ''} {fullName}</p>
						:
						<p style={{marginTop:'0px' , marginBottom:'0px' , marginRight:'6px' , width:'130px' }}>{'Detail'}</p>
					}
 
					<div style={{display:'flex' , flexDirection: 'column' , padding:'10px 0px'}}>
						{shifts.map((item) => (
							<Chip
								key={item.Shift_Number}
								label={[
									item?.absent_reason,
									item.Status === "O"
										? "Open Position"
										: item.Status === "Q"
										? "Requested"
										: item.Status === "D"
										? "Do not fill"
										: item.Status === "R"
										? `Ordered (${(item?.OSLogEmployeeEA_Rank || '') + " " + item?.OSLogEmployeeFirst_name + " " + item?.OSLogEmployeeLast_name})`
										: item.Status === "F"
										? `Filled (${(item?.OSLogEmployeeEA_Rank || '') + " " + item?.OSLogEmployeeFirst_name + " " + item?.OSLogEmployeeLast_name})`
										: "Other",
									shiftsData.find((shift) => shift.ShiftCode == item.Shift_Code)?.Shift || `(${item?.Start_Time} - ${item?.End_Time})`,
								]
									.filter(Boolean) 
									.join(" • ")} 
								sx={{
									backgroundColor:
										item.Status === "O"
											? "#E62719"
											: item.Status === "Q"
											? "#FFA500" 
											: item.Status === "D"
											? "#000000"
											: item.Status === "R"
											? "#000000"
											: item.Status === "F" 
											? "#079E46"
											: "#e0e0e0",
									color: "#ffffff",
									fontSize:'12px',
									margin:'2px 6px',
								}}
							/>
						))}
					</div>

					{shiftsNew &&
						<div style={{display:'flex' , flexDirection: 'column' , padding:'10px 0px'}}>
							<Chip
								key={shiftsNew.Shift_Number}
								label={[
									shiftsNew?.absent_code?.SO_Desc,
									shiftsNew?.Status === "O"
										? "Open Position"
										: shiftsNew?.Status === "Q"
										? "Requested"
										: shiftsNew?.Status === "D"
										? "Do not fill"
										: shiftsNew?.Status === "R"
										? `Ordered (${shiftsNew?.filled_employee?.employee?.fullName})`
										: shiftsNew?.Status === "F"
										? `(${shiftsNew?.filled_employee?.employee?.fullName})`
										: "Other",
									shiftsData.find((shift) => shift.ShiftCode == row?.Shifts[0])?.Shift,
								]
									.filter(Boolean) 
									.join(" • ")}
								sx={{
									backgroundColor:
										shiftsNew?.Status === "O"
											? "#E62719"
											: shiftsNew?.Status === "Q"
											? "#FFA500" 
											: shiftsNew?.Status === "D"
											? "#000000"
											: shiftsNew?.Status === "R"
											? "#000000"
											: shiftsNew?.Status === "F" 
											? "#079E46"
											: "#e0e0e0",
									color: "#ffffff",
									fontSize:'12px',
									margin:'2px 6px',
								}}
							/>
						</div>
					}

					{!fullName &&
						<div style={{display:'flex' , flexDirection: 'column' , padding:'10px 0px'}}>
							<Chip
								key={row.id}
								label={[
									row?.StatusText,
									row.ShiftName,
								]
									.filter(Boolean) 
									.join(" • ")}
								sx={{
									backgroundColor:
										row?.StatusCode === "O"
											? "#E62719"
											: row?.StatusCode === "Q"
											? "#FFA500" 
											: row?.StatusCode === "D"
											? "#000000"
											: row?.StatusCode === "R"
											? "#000000"
											: row?.StatusCode === "F" 
											? "#079E46"
											: "#e0e0e0",
									color: "#ffffff",
									fontSize:'12px',
									margin:'2px 6px',
								}}
							/>
						</div>
					}

				</div>
			);
		}
	};

  const columns = [
		...(values == 0) ? [
			{
				field: 'fullName',
				headerName: 'Name',
				flex: 1,
				minWidth: 200,
				valueGetter: (params) => {
					const emp = params.row.employee;
					const fullName = params.row.fullName || (emp ? emp.fullName : '');
					const rank = params.row.EA_Rank || (emp ? emp.EA_Rank : '');
					return `${rank ? rank + ' ' : ''}${fullName}` || `Detail`;
				},
			}] : [
				{
					field: 'fullName',
					headerName: 'Name',
					minWidth:500,
					flex:1,
					renderCell : (params) => getDisplayName(params.row),
				},
		],
		{
			field: 'group',
			headerName: 'Group',
			flex: 1,
			minWidth: 200,
			valueGetter: (params) => {
				return params.row.Group_Code || params.row.position_assignments?.Group_Code || '';
			},
		},
		{
			field: 'assignment',
			headerName: 'Assignment',
			flex: 1,
			minWidth: 200,
			valueGetter: (params) => {
				return params.row.Assignment_Code || params.row.position_assignments?.Assignment_Code || params.row.AssignmentCode || '';
			},
		},
		{
			field: 'position',
			headerName: 'Position',
			flex: 1,
			minWidth: 200,
			valueGetter: (params) => {
				return params.row.PositionName || params.row.position_assignments?.position_name?.SO_Desc || params.row.PositionName ||  '';
			},
		},
	];

  let openRuncard = () => {
    navigate('/firehouse/RunCard?myteamDate=' + date)
  }

  useEffect(() => {
    if (openCollapse) {
      setTimeout(() => { handlePrint(); }, 3000)
    }
    return () => {
      clearTimeout();
    }
  }, [openCollapse])

  const filteredRows = rows.filter((row) => {
		const fullName =
			row.fullName ||
			row.employee?.fullName ||
			`${row.First_name || ''} ${row.Last_name || ''}`.trim();

		return (
			row.Emp_Code !== user.Emp_Code &&
			fullName.toLowerCase().includes(searchText.toLowerCase())
		);
	});

	const filteredRows2 = rows2.filter((row) => {
		const fullName = row.fullName 
			|| row.employee?.fullName 
			|| `${row.First_name || ''} ${row.Last_name || ''}`.trim();
		
		return fullName.toLowerCase().includes(searchText.toLowerCase());
	});


  return (
    <>
      {/* <ManagementHeaderNav /> */}
      <Paper className='p-3' style={{ marginTop: "1rem" }} >
        <div>
          <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
            <Grid item xs={12}>
              <Typography variant="h5">My Team</Typography>
              <div className='my-3'>
                <div className='d-flex justify-content-between flex-wrap '>
                  <Grid container spacing={2}>
                    <Grid item xs={7}>
                      <MyTeamHeader value={values} setValue = {setValues} />
                    </Grid>
										 <Grid item xs={3} sx={{marginTop:'-4px'}}>
											<TextField
												variant="outlined"
												placeholder="Search by Name"
												className="w-100"
												value={searchText}
    										onChange={(e) => setSearchText(e.target.value)} 
												InputProps={{
													endAdornment: (
														<InputAdornment position="end">
															<IconButton>
																<SearchIcon />
															</IconButton>
														</InputAdornment>
													),
													sx: {
														height: '48px',
														fontSize: '14px'
													},
												}}
											/>
										</Grid>
                    <Grid item xs={2}>
                      <ButtonTheme onClick={openRuncard} color='primary'>
                        Run Card
                      </ButtonTheme>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>


        {loading && <Box className="w-100 d-flex justify-content-center align-items-center"
          style={{ height: '505px' }}>
          <CircularProgress />
        </Box>
        }
        {!loading && filteredRows.length > 0 && values == 0 &&
          <>
            <div ref={printRef}>
              <Box sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
                <MyTable
					rows={filteredRows}
					columns={columns}
					checkboxSelection={false}
					useTopFilter={false}
					rowCount={filteredRows.length}
					perPage={100}
                />
              </Box>
            </div>
          </>
        }

        {!loading && filteredRows.length == 0 && values == 0 &&
          <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 505 }}>
            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
            <span className='mt-4' style={{ color: '#555555' }}>
              No Members Found
            </span>
          </div>
        }

				 {!loading && filteredRows2.length > 0 &&  values == 1 &&
          <>
            <div ref={printRef}>
              <Box sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
                <MyTable
                  rows={filteredRows2}
                  columns={columns}
                  checkboxSelection={false}
                  useTopFilter={false}
									rowCount={filteredRows2.length}
									perPage={100}
                />
              </Box>
            </div>
          </>
        }

      </Paper>
    </>
  )
}
